export const Footer = () => (
  <footer className="border-t border-ink/10 bg-cream">
    <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
      <div className="flex flex-col justify-between gap-12 md:flex-row">
        <div className="max-w-sm">
          <span className="notranslate font-serif text-4xl text-ink" translate="no">NEED</span>
          <p className="mt-4 text-sm leading-relaxed text-ink-soft">
            Gli essenziali che ricompri ogni mese, riuniti in un unico rituale.
            Casa, cura, vestiario, viaggio, pet e ufficio.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-12 sm:grid-cols-4">
          <div>
            <p className="mb-4 text-xs uppercase tracking-overline text-ink-soft">Prodotti</p>
            <ul className="space-y-2 text-sm text-ink">
              <li>Casa</li><li>Pulizia</li><li>Benessere</li><li>Pet</li>
            </ul>
          </div>
          <div>
            <p className="mb-4 text-xs uppercase tracking-overline text-ink-soft">Abbonamento</p>
            <ul className="space-y-2 text-sm text-ink">
              <li>Box Mensile</li><li>Lista ricorrente</li><li>Come funziona</li>
            </ul>
          </div>
          <div>
            <p className="mb-4 text-xs uppercase tracking-overline text-ink-soft">Contatti</p>
            <ul className="space-y-2 text-sm text-ink">
              <li><a href="mailto:need123shop@gmail.com" className="hover:text-electric">need123shop@gmail.com</a></li><li>Instagram</li><li>Newsletter</li>
            </ul>
          </div>
          <div>
            <p className="mb-4 text-xs uppercase tracking-overline text-ink-soft">Note legali</p>
            <ul className="space-y-2 text-sm text-ink">
              <li><a href="/termini" className="hover:text-electric" data-testid="footer-termini">Termini di vendita</a></li>
              <li><a href="/privacy" className="hover:text-electric" data-testid="footer-privacy">Privacy Policy</a></li>
              <li><a href="/cookie" className="hover:text-electric" data-testid="footer-cookie">Cookie Policy</a></li>
              <li><a href="#" data-lb="c-settings" className="hover:text-electric" data-testid="footer-cookie-settings">Preferenze cookie</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-col justify-between gap-4 border-t border-ink/10 pt-8 text-xs text-ink-soft md:flex-row">
        <span>© {new Date().getFullYear()} Violanti Claudia — P.IVA 18685151005 — NEED, essenziali mensili.</span>
        <span>Progettato per chi compra ogni mese.</span>
      </div>
    </div>
  </footer>
);
